import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReportsComponent } from './reports.component';
import { ReportDashboardComponent } from './report-dashboard/report-dashboard.component';
import { OpdDateWiseReportComponent } from './OpdReport/opd-date-wise-report/opd-date-wise-report.component';
import { PatientRegistrationDateWiseComponent } from './RegistrationReport/patient-registration-date-wise/patient-registration-date-wise.component';
import { GraphicalPaitentRegistrationReportComponent } from './RegistrationReport/graphical-paitent-registration-report/graphical-paitent-registration-report.component';
import { PatientCategoryWiseReportComponent } from './RegistrationReport/patient-category-wise-report/patient-category-wise-report.component';
import { PatientRegistrationZoneWiseComponent } from './RegistrationReport/patient-registration-zone-wise/patient-registration-zone-wise.component';
import { OpdDoctorWiseComponent } from './OpdReport/opd-doctor-wise/opd-doctor-wise.component';
import { AppointmentRegisterDoctorWiseComponent } from './OpdAppointment/appointment-register-doctor-wise/appointment-register-doctor-wise.component';
import { SurgeryDateWiseReportComponent } from './SurgeryReports/surgery-date-wise-report/surgery-date-wise-report.component';
import { OperationDateWiseReportComponent } from './SurgeryReports/operation-date-wise-report/operation-date-wise-report.component';
import { OpdMonthWiseReportComponent } from './OpdReport/opd-month-wise-report/opd-month-wise-report.component';
import { SurgeonWiseSummaryReportComponent } from './SurgeryReports/surgeon-wise-summary-report/surgeon-wise-summary-report.component';
import { OperationTypeWiseSummaryComponent } from './SurgeryReports/operation-type-wise-summary/operation-type-wise-summary.component';
import { SurgeonWiseMonthComponent } from './SurgeryReports/surgeon-wise-month/surgeon-wise-month.component';
import { OperationWiseMonthComponent } from './SurgeryReports/operation-wise-month/operation-wise-month.component';
import { OpdreportsComponent } from './OpdReport/opdreports/opdreports.component';
import { RegistrationcommonreportsComponent } from './RegistrationReport/registrationcommonreports/registrationcommonreports.component';
import { AdvanceRegisterComponent } from './receipt-payment/advance-register/advance-register.component';
import { AppointmentSummaryDoctorWiseReportComponent } from './OpdAppointment/appointment-summary-doctor-wise-report/appointment-summary-doctor-wise-report.component';
import { misReportComponent } from './mis-report/mis-report.component';
import { PreOperativeAssesmentSheetComponent } from './pre-operative-assesment-sheet/pre-operative-assesment-sheet.component';


const routes: Routes = [
  {path:'', component:ReportsComponent,
  children:[
   {path:'',component:ReportDashboardComponent},

   {path:'opd-reports',component:OpdreportsComponent},
   {path:'advance-register',component:AdvanceRegisterComponent},
   
//  {path:'opd-date-wise-report',component:OpdDateWiseReportComponent},
//  {path:'opd-month-wise-report',component:OpdMonthWiseReportComponent},
//  {path:'opd-doctor-wise',component:OpdDoctorWiseComponent},
 {path:'registration-reports',component:RegistrationcommonreportsComponent},
 {path:'patient-registration-date-wise',component:PatientRegistrationDateWiseComponent},
 {path:'graphical-patient-registration',component:GraphicalPaitentRegistrationReportComponent},
 {path:'patient-category-wise',component:PatientCategoryWiseReportComponent},
 {path:'patient-zone-wise',component:PatientRegistrationZoneWiseComponent},

 {path:'appointment-register-doctor-wise',component:AppointmentRegisterDoctorWiseComponent},
 {path:'surgery-date-wise-reports',component:SurgeryDateWiseReportComponent},
 {path:'operation-date-wise-reports',component:OperationDateWiseReportComponent},
 {path:'surgeon-wise-summary',component:SurgeonWiseSummaryReportComponent},
 {path:'operation-type-wise-summary',component:OperationTypeWiseSummaryComponent},
 {path:'surgeon-month-wise-reports',component:SurgeonWiseMonthComponent},
 {path:'operation-month-wise-reports',component:OperationWiseMonthComponent},
 {path:'Pre_Operative_Assesment_Sheet',component:PreOperativeAssesmentSheetComponent},

 {
  path: 'billing',
  loadChildren: () => import('./billing-report/billing-report.module').then(m => m.BillingReportModule)
},
{path:'appointment-summary-doctor-wise-report',component:AppointmentSummaryDoctorWiseReportComponent},
{path:'mis-report',component:misReportComponent},
  ]}

 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
